import {BehaviorSubject, Subject} from 'rxjs';
import {skipUntil, filter} from 'rxjs/operators';
import {mc} from '@/core';
import {envUtil} from '@/helper/env';
import {activityApi} from '@/api/activity';
import {lang$} from '@/store/lang';
import {browser$} from '@/streams/browser';
import {userStatus$} from '@/streams/auth';

export const defaultBonusDetail = {
  newBonusAmount: 4800,
  oldBonusAmount: 8800,
  excludeCountry: 'JP,KR',
  showDays: '30',
};

export const totalBonus$ = new BehaviorSubject('--');
export const welcomeBonusDetail$ = new BehaviorSubject(defaultBonusDetail);
export const welcomeBonusLoading$ = new BehaviorSubject(false);

lang$.subscribe((lang) => {
  if (!process.browser) {
    return;
  }
  welcomeBonusLoading$.next(true);
  activityApi.getWelcomeBonusAmount(lang).then(({data = {}}) => {
    totalBonus$.next(data ? data.content.replace('$', '<span>$</span>') : '--');
    // 新增一个流，防止与老逻辑冲突
    welcomeBonusDetail$.next(data);
    welcomeBonusLoading$.next(false);
  });
});

export const loadActivityInfo$ = new Subject();

export const registerActivity$ = new BehaviorSubject({});

loadActivityInfo$.subscribe(async () => {
  const {data, error} = await activityApi.getCustomizeActivityInfo(getActivityId());
  if (data) {
    registerActivity$.next({
      ...data,
      pageInfo: JSON.parse(data.pageInfo) || [],
    });
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
});

export function subscribeUserStatus(trRegistering) {
  userStatus$
    .pipe(
      skipUntil(browser$),
      filter((status) => status === 'Logout' && !trRegistering && !envUtil.isMobile && !envUtil.isApp)
    )
    .subscribe(() => loadActivityInfo$.next());
}

function getActivityId() {
  if (envUtil.isProduction || envUtil.isEaProduction) {
    return '4';
  }
  if (envUtil.isDev) {
    return '6';
  }
  return '7';
}
